import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress harmless Google Maps CSP test errors that are blocked by ad blockers
// These errors don't affect functionality - they're just analytics/tracking requests
const originalError = console.error;
console.error = (...args) => {
  const errorMessage = args.join(' ');
  // Filter out ERR_BLOCKED_BY_CLIENT errors for Google Maps gen_204 endpoint
  if (errorMessage.includes('ERR_BLOCKED_BY_CLIENT') && 
      (errorMessage.includes('maps.googleapis.com') || errorMessage.includes('gen_204'))) {
    // Suppress this harmless error (caused by ad blockers blocking Google Maps analytics)
    return;
  }
  // Log all other errors normally
  originalError.apply(console, args);
};

// Also suppress unhandled promise rejections for the same error
// And handle authentication errors globally
window.addEventListener('unhandledrejection', async (event) => {
  const errorMessage = event.reason?.message || event.reason?.toString() || '';
  const errorResponse = event.reason?.response;
  
  // Suppress harmless Google Maps errors
  if (errorMessage.includes('ERR_BLOCKED_BY_CLIENT') && 
      (errorMessage.includes('maps.googleapis.com') || errorMessage.includes('gen_204'))) {
    event.preventDefault(); // Suppress the error
    return;
  }
  
  // Check for authentication errors
  const isAuthError = 
    errorResponse?.status === 401 || 
    errorResponse?.status === 403 ||
    errorMessage.includes('NotAuthorizedException') ||
    errorMessage.includes('Unauthenticated') ||
    errorMessage.includes('Unauthorized') ||
    errorMessage.includes('identity pool') ||
    errorMessage.includes('forbidden') ||
    errorMessage.includes('Access to Identity') ||
    (errorResponse?.status === 400 && 
     (errorResponse?.config?.url?.includes('cognito') || 
      errorResponse?.config?.url?.includes('cognito-identity') ||
      errorResponse?.data?.__type?.includes('NotAuthorizedException')));
  
  if (isAuthError) {
    event.preventDefault(); // Prevent default error logging
    console.error('Authentication error detected, redirecting to login:', errorMessage);
    
    // Import signOut dynamically to avoid circular dependencies
    try {
      const { signOut } = await import('@aws-amplify/auth');
      await signOut();
    } catch (signOutError) {
      console.error('Error signing out:', signOutError);
    }
    
    // Redirect to login page
    window.location.href = '/auth';
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
